import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LicenceHolderService } from '@services/licence_holder.service';
import { LocationSelectorService } from '@services/location_selector.service';
import { sharedResolution } from '../../../../src/shared_resolution';
import { SpaContext } from '../../Classes/spacontext';
import { AuthServiceV2 } from '../../Services/api/v2/auth.service';
import { IdentityServiceV2 } from '../../Services/api/v2/identity.service';
import { UsageAgreementsService } from '../../Services/api/v2/usageAgreements.service';
import { AuthContextService } from '../../Services/authContext.service';
import { AuthMethodApiModel } from '../../Services/Models/Auth/AuthMethodApiModel';
import { AuthenticationMethodApiModel } from '../../Services/Models/General/AuthenticationMethodApiModel';
import { SpaEventService } from '../../Services/spaEvents.service';
import type { SignInOnFinishedEvent } from './SignInOnFinishedEvent';

const NO_SCROLL_CLASS_NAME = 'js-noScroll';

export enum OpenTargetWith {
	AngularNavigation = 'AngularNavigation',
	NativeNavigation = 'NativeNavigation',
	NewTab = 'NewTab',
}

@Component({
	standalone: false,
	selector: 'visiba-signin',
	template: `
		<ng-container *ngIf="useCareExperiencePwIDP; then newSignIn; else oldSignIn"> </ng-container>

		<ng-template #newSignIn>
			<sign-in-modal-wrapper></sign-in-modal-wrapper>
		</ng-template>

		<ng-template #oldSignIn>
			<div class="outerWrapper overlay" (click)="abort()"></div>

			<div class="container">
				<div class="innerWrapper" id="js-innerRef">
					<div class="innerContent" trapFocus *ngIf="view == 'method'">
						<div class="countrySelect" *ngIf="countryList.length > 1">
							<visiba-select
								[(ngModel)]="countryCode"
								[options]="countryList"
								placeholder="LicenceHolder.Component.SignIn.Placeholder.ChooseNationality"
								(onChange)="getAuthMethods(countryCode)"
								label="Name"
								value="CountryCode"
							></visiba-select>
						</div>

						<div class="loginReason" *ngIf="reasonText !== null">
							<div class="title">{{ 'LicenceHolder.Component.SignIn.Title.LoginNeeded' | translate }}</div>
							{{ reasonText }}
						</div>

						<div class="methodDirectives" #methodDirectives>
							<div class="marginBottom2" *ngIf="countryCode === 'GB'; else allOtherCountries">
								<div *ngIf="!nhsLoading" class="marginBottom2">
									<h2>{{ 'LicenceHolder.Defaults.Views.View_SignInMethod_Title' | translate }}</h2>
									<p>{{ 'LicenceHolder.Component.SignIn.Nhs.LoginDescription' | translate }}</p>
								</div>
								<div *ngFor="let method of methods">
									<div *ngIf="method.MethodId === 'NhsOidc'" class="marginBottom4">
										<visibacare-iframe-auth
											[returnUrl]="returnUrl"
											[ticket]="callTicket"
											[countryCode]="countryCode"
											[method]="chosenMethod"
											[availableMethods]="methods"
											(onFinished)="onFinished($event)"
											(nhsLoading)="handleNhsLoading($event)"
										></visibacare-iframe-auth>
									</div>
									<div *ngIf="method.MethodId === 'SMS' && !nhsLoading" class="marginBottom2">
										<sms-login
											(onFinished)="onFinished($event)"
											[countryCode]="countryCode"
											[ticket]="callTicket"
											[isOutsider]="authMethod"
										></sms-login>
									</div>
									<div *ngIf="method.MethodId === 'QuickAuth' && !nhsLoading" class="marginBottom2">
										<quick-auth (onFinished)="onFinished($event)" [countryCode]="countryCode"></quick-auth>
									</div>
									<div *ngIf="method.MethodId === 'NoAuth' && !nhsLoading" class="marginBottom2">
										<no-auth-login (onFinished)="onFinished($event)" [ticket]="callTicket" [countryCode]="countryCode"></no-auth-login>
									</div>
								</div>
							</div>
							<ng-template #allOtherCountries>
								<div [ngSwitch]="visibleMethodDirective">
									<ng-template [ngSwitchCase]="'VisibaCare_SMS'">
										<sms-login
											(onFinished)="onFinished($event)"
											[countryCode]="countryCode"
											[ticket]="callTicket"
											[isOutsider]="authMethod"
										></sms-login>
									</ng-template>
									<ng-template [ngSwitchCase]="'VisibaCare_QuickAuth'">
										<quick-auth (onFinished)="onFinished($event)" [countryCode]="countryCode"></quick-auth>
									</ng-template>
									<ng-template [ngSwitchCase]="'ehelse'">
										<signin-method-ehelse [ticket]="callTicket"></signin-method-ehelse>
									</ng-template>
									<ng-template [ngSwitchCase]="'Iframe'">
										<visibacare-iframe-auth
											[returnUrl]="returnUrl"
											[ticket]="callTicket"
											[countryCode]="countryCode"
											[method]="chosenMethod"
											(onFinished)="onFinished($event)"
										></visibacare-iframe-auth>
									</ng-template>
									<ng-template [ngSwitchCase]="'VisibaCare_NoAuth'">
										<no-auth-login (onFinished)="onFinished($event)" [ticket]="callTicket" [countryCode]="countryCode"></no-auth-login>
									</ng-template>
									<ng-template [ngSwitchCase]="null">
										<p>{{ 'LicenceHolder.Component.SignIn.Title.NoMethodsForNationality' | translate }}</p>
									</ng-template>
								</div>
							</ng-template>
						</div>

						<div class="row error marginBottom2" *ngIf="errorMessage != null">{{ errorMessage }}</div>
						<div *ngIf="countryCode !== 'GB'" class="row methods">
							<span *ngIf="methods.length > 1">{{ 'LicenceHolder.Component.SignIn.Title.OtherMethods' | translate }}</span>
							<div class="list">
								<button
									class="list-item"
									type="text"
									(click)="selectMethod(m)"
									*ngFor="let m of methods"
									[class.selected]="m === chosenMethod"
								>
									<img class="logInTypeImg" [src]="m.ImageUrl" />
									<div>
										{{ 'Common.AuthType.' + m.ProviderId.replace(' ', '_') + '.' + m.MethodId.replace(' ', '_') | translate }}
									</div>
								</button>
							</div>
						</div>

						<button
							type="text"
							class="cancel"
							[attr.aria-label]="'Common.Button.Close' | translate"
							(click)="abort()"
							*ngIf="!authMethod"
						>
							<visiba-svg a="X"></visiba-svg>
						</button>
					</div>
				</div>
			</div>
		</ng-template>
	`,
	styleUrls: ['../../Css/Components/signIn.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class SignInComponent implements OnInit, OnDestroy {
	@Input('target') returnUrl: string = null;
	@Input('openTargetWith') openTargetWith: OpenTargetWith = OpenTargetWith.AngularNavigation;
	@Input('reason') reasonText: string = null;
	@Input('ticket') callTicket: string = null;
	@Input('error') errorMessage: string = null;
	@Input('leave') leave: boolean = true;
	@Input('authMethod') authMethod: AuthenticationMethodApiModel | null = null;
	@ViewChild('methodDirectives', { static: false }) public methodDirectivesRef: ElementRef;

	useCareExperiencePwIDP = null;
	authAttemptId: string;
	methods: Array<AuthMethodApiModel>;
	chosenMethod: AuthMethodApiModel = null;
	visibleMethodDirective: string = null;
	countryCode: string = null;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	countryList: Array<any> = [];
	view: 'method' = null;
	nhsLoading: boolean = false;
	iframeMessageDisposer: () => void;

	constructor(
		private _spaContext: SpaContext,
		private _router: Router,
		private _spaEventService: SpaEventService,
		private _identityService: IdentityServiceV2,
		private authService: AuthServiceV2,
		private translateService: TranslateService,
		private authContextService: AuthContextService,
		private usageAgreementsService: UsageAgreementsService,
	) {}

	ngOnInit() {
		this.useCareExperiencePwIDP = this.shouldShowIDPMethods(this.returnUrl);

		if (this.authContextService.patientIdentity !== null && this.returnUrl !== null) {
			this._identityService.isAlive().subscribe((result) => {
				if (result.data) this._router.navigate([decodeURIComponent(this.returnUrl)]);
				else {
					this.authContextService.signInPatient(null, false);
				}
			});
		}

		if (this.useCareExperiencePwIDP) {
			const callback = (event) => {
				if (event.data === 'sign-in-finished') {
					this.completeSignIn();
					globalThis.removeEventListener('message', callback);
				}
			};

			globalThis.addEventListener('message', callback);

			this.iframeMessageDisposer = () => {
				globalThis.removeEventListener('message', callback);
			};

			return;
		}

		if (this.authMethod) {
			this.countryList = this._spaContext.unitConfig.Locale.SupportedCountries.filter(
				(country) => country.CountryCode === this.authMethod.CountryCode,
			);
			this.countryCode = this.authMethod.CountryCode;
		} else {
			this.countryList = this._spaContext.unitConfig.Locale.SupportedCountries;
			this.countryCode = this._spaContext.unitConfig.Locale.DefaultCountry;
		}
		this.getAuthMethods(this.countryCode);

		window.angularSignInModalIsOpen = true;

		document.body.classList.add(NO_SCROLL_CLASS_NAME);
	}

	ngOnDestroy() {
		document.body.classList.remove(NO_SCROLL_CLASS_NAME);

		window.angularSignInModalIsOpen = false;

		this.iframeMessageDisposer?.();
	}

	public handleNhsLoading(event: boolean) {
		this.nhsLoading = event;
	}

	getAuthMethods(countryCode: string) {
		if (countryCode === null) return;
		this.view = null;

		this.authService.getAuthMethods(countryCode, this.callTicket, this._spaContext.unitConfig.Unit.UnitId).subscribe(
			(response) => {
				if (this.authMethod) {
					// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
					this.methods = response.filter((method) => method.MethodId === this.authMethod.AuthenticationMethodId) as any;
				} else {
					// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
					this.methods = response as any;
				}
				this.view = 'method';

				if (this.methods.length === 0) {
					this.chosenMethod = null;
					this.visibleMethodDirective = null;

					return;
				}

				let method = this.methods[0];
				if (localStorage.getItem('X-App-PublicSignInMethod') !== null && countryCode !== 'GB') {
					const results = this.methods.filter(
						(x) =>
							x.ProviderId === localStorage.getItem('X-App-PublicSignInMethod').split('_')[0] &&
							x.MethodId === localStorage.getItem('X-App-PublicSignInMethod').split('_')[1],
					);
					if (results.length > 0) method = results[0];
				}

				this.selectMethod(method);
			},
			// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
			(error) => {},
		);
	}

	selectMethod(method: AuthMethodApiModel): void {
		const combId = method.ProviderId + '_' + method.MethodId;

		this.chosenMethod = method;
		this.visibleMethodDirective = combId;
		localStorage.setItem('X-App-PublicSignInMethod', combId);

		if (this.methodDirectivesRef != null) {
			this.methodDirectivesRef.nativeElement.tabIndex = 0;
			this.methodDirectivesRef.nativeElement.focus();
			this.methodDirectivesRef.nativeElement.onBlur = () => {
				this.methodDirectivesRef.nativeElement.tabIndex = -1;
			};
		}

		if (combId === 'VisibaCare_SMS') return;

		if (combId === 'VisibaCare_QuickAuth') return;

		if (combId === 'VisibaCare_NoAuth') return;

		if (method.MethodId === 'ehelse') {
			this.visibleMethodDirective = 'ehelse';

			return;
		}

		this.visibleMethodDirective = 'Iframe';
	}

	abort() {
		this._spaEventService.onSignInAborted.emit();
		if (this.leave) {
			const licenceHolderService = sharedResolution.resolve(LicenceHolderService);
			this._router.navigateByUrl('/' + licenceHolderService.alias);
		}
	}

	back() {
		this.abort();
	}

	onFinished(event: SignInOnFinishedEvent) {
		if (event.code === 'Signed') {
			this.checkDocumentSigning();
		} else if (event.code === 'Register') {
			this._spaEventService.onRegistrationRequired.emit({ target: this.returnUrl, ticket: event.data.ticket });
		} else if (event.code === 'Cancel') {
			this.back();
		} else if (this.chosenMethod.Name === 'NHS' && event.code === 'Failed' && event.data.errorMessage.startsWith('Consent')) {
			this.errorMessage = this.translateService.get('LicenceHolder.Component.SignIn.Error.NhsConsent');
		} else {
			this.errorMessage = this.translateService.get('LicenceHolder.Common.Error.Authentication.' + event.data.errorCode);
		}
	}

	checkDocumentSigning() {
		this.usageAgreementsService.getSignatureDocuments(this._spaContext.unitConfig.LicenceHolder.Id).subscribe(
			(response) => {
				if (!response.data.PrivacyPolicy.HasSigned || !response.data.TermsOfService.HasSigned) {
					this._spaEventService.onDocumentsSigningNeeded.emit(response.data);

					const signingSubscription = this._spaEventService.onDocumentsSigningCompleted.subscribe((documents) => {
						this.completeSignIn();
						signingSubscription.unsubscribe();
					});

					return;
				}

				this.completeSignIn();
			},
			// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
			(error) => {},
		);
	}

	completeSignIn() {
		this._identityService.get().subscribe(
			() => {
				this.authContextService.signInPatient(null);
				if (this.authMethod && this.callTicket) this.authContextService.isAuthenticatedOutsider = true;
				switch (this.openTargetWith) {
					case OpenTargetWith.NewTab: {
						window.open(this.returnUrl);

						const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
						this._router.navigateByUrl('/' + locationSelectorService.location.route);
						break;
					}
					case OpenTargetWith.NativeNavigation: {
						window.location.href = this.returnUrl;
						break;
					}
					case OpenTargetWith.AngularNavigation: {
						this._router.navigateByUrl(this.returnUrl);
						break;
					}
				}
			},
			// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
			(error) => {},
		);
	}

	private shouldShowIDPMethods(returnUrl: string) {
		const split = decodeURIComponent(returnUrl).split('?');
		if (split.length === 2 && new URLSearchParams(split[1]).get('legacy') === 'true') {
			return false;
		}

		return window.__visiba_feature_flags__['CareExperience.PW.Idp'];
	}
}
